module.exports = __webpack_public_path__ + "img/電気回路_2_5_5.3da24ea1.png";